import { useDispatch, useSelector } from 'react-redux';
import { stateToQuery, queryToStateQuery } from '../../../features/request/reducers';
import { setRequest } from '../../../features/request/actions';
import { fetchSearchResults } from '../../../features/searchResults/actions';
import SearchUrl from '../components/SearchUrl';
import { RootState } from '../../../config/redux/types';
import { RequestStateQuery } from '../../../features/request/types';

export default function SearchUrlContainer(): JSX.Element {
  const request = useSelector((state: RootState) => state.request);
  const dispatch = useDispatch();

  function buildNewRequestState(query: RequestStateQuery | undefined): void {
    if (!query) {
      return;
    }
    const stateFromQuery = queryToStateQuery(query);
    const newRequest = {
      ...request,
      ...stateFromQuery.requestState,
      filterSet: {
        ...request.filterSet,
        ...stateFromQuery.filterSet,
      },
      options: {
        ...request.options,
        ...stateFromQuery.filterOptions,
      },
    };
    dispatch(setRequest(newRequest));
  }

  return (
    <SearchUrl
      query={stateToQuery(request)}
      onChange={(query): void => {
        buildNewRequestState(query);
      }}
      onUrlUpdate={(search): void => {
        dispatch(fetchSearchResults(search));
      }}
    />
  );
}
